import { GetValidateAddressCore, WithdrawInitial } from "store/api/withdraw";
import { Grid, Typography, useTheme } from "@mui/material";
import { useMemo, useState } from "react";

import AcceptWithdrawModal from "./Modals/AcceptWithdrawModal";
import ConfirmWithdrawModal from "./Modals/ConfirmWithdrawModal";
import { FixedMidpointRoundingToDown } from "utils/helpers/numbers";
import { LoadingButton } from "@mui/lab";
import NumberFormats from "components/NumberFormats";
import { TYPES } from "pages/Deposit/constants";
import WithdrawNetworkProposalMemo from "./WithdrawNetworkProposalMemo";
import http from "config/http";
import { useFormContext } from "react-hook-form";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";
import SuccessModal from "components/SuccessModal";
import WithdrawConfirmationResult from "./Modals/WithdrawConfirmationResult";
import { useSearchParams } from "react-router-dom";

function WithdrawSubmit({
  selectedCoin,
  withdrawAmountMax,
  selectedNetwork,
  currentNetworkFields,
  getWithdrawInitial,
}) {
  const notify = useNotify();
  const theme = useTheme()
  const [searchParams, setSearchParams] = useSearchParams();

  const { setValue, watch, handleSubmit, getValues, reset } = useFormContext();
  const amount = watch("amount");
  const isDigital = watch("isDigital");
  const address = watch("address");

  const [loading, setLoading] = useState(false);
  const [withdrawInitialConfirm, setWithdrawInitialConfirm] = useState();
  const [withdrawResult, setWithdrawResult] = useState();

  const [openAcceptWithdrawModal, setOpenAcceptWithdrawModal] = useState(false);
  const [openConfirmWithdrawModal, setOpenConfirmWithdrawModal] =
    useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const receiveAmount = useMemo(() => {
    return FixedMidpointRoundingToDown(
      parseFloat(amount) - parseFloat(currentNetworkFields?.withdrawFeeAmount),
      selectedCoin?.decimalPlacesWithdraw
    );
  }, [
    amount,
    currentNetworkFields?.withdrawFeeAmount,
    selectedCoin?.decimalPlacesWithdraw,
  ]);

  const onAccept = async () => {
    const allValues = Object.entries(getValues());
    const filledValues = allValues.filter(([_, v]) => v !== "");
    const bringBackObjectFromEntries = Object.fromEntries(filledValues);

    const body = {
      ...bringBackObjectFromEntries,
    };

    delete body.isDigital;

    try {
      setLoading(true);

      const { data } = await http.post(WithdrawInitial, body);
      setWithdrawInitialConfirm(data?.data);
      setOpenAcceptWithdrawModal(false);
      setOpenConfirmWithdrawModal(true);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false);
  };

  const onWithdraw = async ({ address, networkId, coinId, typeId }) => {
    const isTypeCore = typeId === TYPES.core;
    if (isTypeCore) {
      try {
        await http.get(GetValidateAddressCore({ address, coinId, networkId }));
        setOpenAcceptWithdrawModal(true);
      } catch (e) {
        notify("آدرس ولت صحیح نمی‌باشد.", "error");
      }
    } else {
      setOpenAcceptWithdrawModal(true);
    }
  };

  const changeSection = () => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      sideId: 2,
      inSideId: 0
    });

    const el = document.getElementById("history-section");
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth" });
      }, 500)
    }
  };

  const isWithdrawDisabled = () => {
    const fieldsToFill = {
      isHaveAddress: "address",
      isHaveTagOrMemo: "tagOrMemo",
    };

    if (currentNetworkFields) {
      const keys = Object.keys(currentNetworkFields);
      const fieldsThatShouldBeFilled = keys.filter(
        (key) => !!fieldsToFill?.[key] && currentNetworkFields[key] === true
      );

      const checkIfAllFieldsAreFilled = fieldsThatShouldBeFilled.every(
        (field) => watch(fieldsToFill[field])
      );

      return !checkIfAllFieldsAreFilled || !amount;
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          color="text.secondary"

        >
          <Typography pb={2} variant="h4">
            Available:{" "}
            <Typography variant="h4" component="b" color="secondary">
              <NumberFormats value={withdrawAmountMax?.availableBalance || 0} />
            </Typography>
          </Typography>
          <Typography variant="h6" color="text.secondary"></Typography>
          Withdraw Amount Max:{" "}
          <Typography
            variant="h6"
            component="b"
            color="secondary"
            onClick={() =>
              setValue("amount", withdrawAmountMax?.withdrawAmountMax || 0)
            }
          >
            <NumberFormats value={withdrawAmountMax?.withdrawAmountMax || 0} />
          </Typography>
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"

        >
          Minimum:{" "}
          <Typography
            variant="h6"
            component="b"
            color="secondary"
            onClick={() =>
              setValue("amount", selectedCoin?.minimumWithdrawAmount || 0)
            }
          >
            <NumberFormats value={selectedCoin?.minimumWithdrawAmount || 0} />
          </Typography>
        </Typography>

        {isDigital && (
          <Typography variant="h6" color="text.secondary">
            Fee:{" "}
            <Typography variant="h6" component="b" color="secondary">
              <NumberFormats
                value={currentNetworkFields?.withdrawFeeAmount || 0}
              />
            </Typography>
          </Typography>
        )}
      </Grid>

      {isDigital && (
        <Grid item xs={12}>
          <Typography variant="h6" color="text.secondary">
            Receive Amount:{" "}
            <Typography variant="h6" component="b" color="secondary">
              <NumberFormats value={receiveAmount || 0} />{" "}
              {selectedCoin?.coinName}
            </Typography>
          </Typography>
        </Grid>
      )}

      <WithdrawNetworkProposalMemo
        currentNetworkFields={currentNetworkFields}
      />
      <Grid item xs={12}>
        <LoadingButton
          disabled={isWithdrawDisabled()}
          onClick={handleSubmit(onWithdraw)}
          color={actionButtonBg(theme)}
          fullWidth
          variant="contained"
        >
          Withdraw
        </LoadingButton>
      </Grid>

      <AcceptWithdrawModal
        selectedNetwork={selectedNetwork}
        receiveAmount={receiveAmount}
        selectedCoin={selectedCoin}
        open={openAcceptWithdrawModal}
        onAccept={onAccept}
        loading={loading}
        onClose={() => setOpenAcceptWithdrawModal(false)}
      />

      {openConfirmWithdrawModal && (
        <ConfirmWithdrawModal
          withdrawInitialConfirm={withdrawInitialConfirm}
          open={openConfirmWithdrawModal}
          address={address}
          onClose={() => {
            setOpenConfirmWithdrawModal(false);
          }}
          setWithdrawResult={setWithdrawResult}
          setOpenConfirmationModal={setOpenConfirmationModal}
        />
      )}

      {openConfirmationModal &&
        <SuccessModal
          title={"Withdraw Successful"}
          subtitle={"Your withdrawal has been completed successfully. The amount will reflect in your account shortly."}
          open={openConfirmationModal}
          onClose={() => {
            getWithdrawInitial();
            reset();
            setOpenConfirmationModal(false);
            changeSection()
          }}
        >
          <WithdrawConfirmationResult withdrawResult={withdrawResult} />
        </SuccessModal>
      }
    </>
  );
}

export default WithdrawSubmit;
